import styled from "styled-components";

const AuthorsContainer = styled.div``;

export { AuthorsContainer };
